/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Settings
 */
export interface Settings {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   * The unique_id of an organisation
   */
  organisation: string;
  /**
   *
   */
  readonly organisationName?: string;
  /**
   * List of historical rain radar UUIDs
   */
  historicalRainRadarUuids?: Array<string>;
  /**
   * List of forecast rain radar UUIDs
   */
  forecastRainRadarUuids?: Array<string>;
}

/**
 * Check if a given object implements the Settings interface.
 */
export function instanceOfSettings(value: object): value is Settings {
  if (!("organisation" in value) || value["organisation"] === undefined) return false;
  return true;
}

export function SettingsFromJSON(json: any): Settings {
  return SettingsFromJSONTyped(json, false);
}

export function SettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Settings {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    id: json["id"] == null ? undefined : json["id"],
    organisation: json["organisation"],
    organisationName: json["organisation_name"] == null ? undefined : json["organisation_name"],
    historicalRainRadarUuids:
      json["historical_rain_radar_uuids"] == null ? undefined : json["historical_rain_radar_uuids"],
    forecastRainRadarUuids:
      json["forecast_rain_radar_uuids"] == null ? undefined : json["forecast_rain_radar_uuids"],
  };
}

export function SettingsToJSON(json: any): Settings {
  return SettingsToJSONTyped(json, false);
}

export function SettingsToJSONTyped(
  value?: Omit<Settings, "url" | "id" | "organisationName"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    organisation: value["organisation"],
    historical_rain_radar_uuids: value["historicalRainRadarUuids"],
    forecast_rain_radar_uuids: value["forecastRainRadarUuids"],
  };
}
